import { z } from "zod";

export const schema = z
	.object({
		param: z
			.object({
				value: z.string().nullable().optional(),
				label: z.string().nullable().optional(),
			})
			.nullable()
			.optional(),
		paramValue: z
			.string()
			.min(1, "O campo de dias é obrigatório")
			.refine((val) => !isNaN(val) && Number.isInteger(Number(val)) && Number(val) > 0, {
				message: "Informe um número inteiro maior que 0",
			}),
		paramDate: z.object({
			value: z.string(),
			label: z.string(),
		}),
		active: z.boolean(),
		salesType: z.string().nullable().optional(),
		clientType: z.string().nullable().optional(),
		situacaoCompra: z.string().nullable().optional(),
		dtIni: z.date({
			required_error: "Data início é obrigatória",
			invalid_type_error: "Data início inválida",
		}),
		dtFim: z.date({
			required_error: "Data fim é obrigatória",
			invalid_type_error: "Data fim inválida",
		}),
	})
	.refine((data) => data.dtIni <= data.dtFim, {
		message: "A data inicial deve ser menor ou igual à data final",
		path: ["dtIni"],
	});
